// Modules
import { useState } from 'react'
import { useSelector } from 'react-redux';
import type { RootState, PlayerWrong } from '../../types/store';
// Project
import AppStore from '../../stores/app-store';
import AppActions from '../../actions/app-actions';
import AppConstants from '../../constants/app-constants';
import AppUtils from '../../utils/app-utils';
import UITimer from '../../components/ui-timer';
import UIHilight from '../../components/ui-hilight';
import Player from '../../components/player';
import '../../css/pulse.css';
import WRONG_IMAGE from '../../assets/drink.svg'
import CORRECT_IMAGE from '../../assets/correct.svg';
import Glass from '../../components/glass/glass';
import Stack from '@mui/material/Stack';
import { Box, Button, Divider, Grid, Typography, useTheme } from '@mui/material';
import FlexCenter from '../../components/flex/flex-center';
import UIBlurBox from '../../components/ui-blur-box';

export default function LobbyDrink() {
    const lobby = useSelector((state: RootState) => state.page.lobby);
    const translate = useSelector((state: RootState) => state.ui.language.lobby.drink);
    const categories = useSelector((state: RootState) => state.ui.language.categories);
    const [showTable, setShowTable] = useState(false);
    const theme = useTheme()
    function onReady() {
        AppStore.dispatch(AppActions.Ready({}));
    }
    function onToggleTable() {
        setShowTable(!showTable);
    }

    const btnStyle = { width: "100%", fontSize: "20px" }

    // Sets text to 'Correct Answer' and defaults to 'DRAW'
    let correct_answer_text: string | undefined = translate.correctAnswer.toUpperCase();
    let correct_answer = translate.draw;
    if (lobby.drink.correct_option && lobby.drink.correct_option.length > 0) {
        correct_answer = lobby.drink.correct_option;
    }

    // correct_answer is set at the end (it also changes status_image and status_text)
    // This is so we can still maintain the options for what everyone voted at

    // In case this question has any extra info, that's good to know
    //if (lobby.drink.question_extra && lobby.drink.question_extra.length > 0) {
    //    extra_info = <Typography>{lobby.drink.question_extra}</Typography>
    //}

    // Our available options - up to 5
    let table_options: React.JSX.Element[][] = [[], [], [], [], []];

    let correct_class = "";
    let status_image = CORRECT_IMAGE;
    let status_text = translate.answerCorrect;

    // Table for correct answers
    if (lobby.drink.correct.length > 0 && lobby.drink.correct_option_id > 0) {
        let correct_id = (lobby.drink.correct_option_id - 1); // We need to -1 because table_options indexes are 0 to 4
        AppUtils.log("[Drinking] correct_id has been set to", correct_id);
        AppUtils.log("[Drinking] Lobby is", lobby);

        // This puts two users per table row
        let row_tmp: React.JSX.Element[] = [];
        lobby.drink.correct.forEach((v) => {
            table_options[correct_id].push(
                <Grid size={{ xs: 6, md: !lobby.playing ? 4 : 6 }}>
                    <Box marginTop={"2px"} display="flex" justifyContent={"center"} alignItems="center" sx={{ fontSize: !lobby.playing ? '0.85rem' : '0.9rem' }}>
                        <Player player={v} />
                    </Box>
                </Grid>
            )
        });
        // If we had any players, add them to the table for the correct option
        if (row_tmp.length > 0) table_options[correct_id].push(<tr key={correct_id + "-last"} className="drink-users">{row_tmp}</tr>);
    }

    // Sorts the incorrect players by option
    let drink_players: PlayerWrong[] = lobby.drink.wrong;
    if (drink_players.length > 0) {
        drink_players = lobby.drink.wrong.sort((a, b) => a.option > b.option ? 1 : -1);
    }
    // Table creation for losers table
    if (drink_players.length > 0) {

        // Loop each player
        drink_players.forEach((v) => {

            // Save status for my guess, and perhaps highlight?
            if (v.nickname.toLowerCase() === lobby.nickname.toLowerCase()) {
                // Change text
                correct_class = "-wrong";
                status_image = WRONG_IMAGE;
                status_text = translate.answerIncorrect;
            }

            // Add option if it has changed
            //if(v.option !== last_option) {
            if (v.option === 0) {
                // Someone forgot to answer..?
                console.log(v.nickname, "failed to answer?!");
                return;
            }

            // Push last options to their own tr
            // This will not trigger on -100, since the row_tmp is null on the first run
            table_options[(v.option - 1)].push(
                <Grid size={{ xs: 6, md: !lobby.playing ? 4 : 6 }}>
                    <Box marginTop={"2px"} display="flex" justifyContent={"center"} alignItems="center" sx={{ fontSize: !lobby.playing ? '0.85rem' : '0.9rem' }}>
                        <Player player={v.nickname} />
                    </Box>
                </Grid>);
            //  }
        });

        // Add the player
        //if(row_tmp.length > 0) table_options[(last_option-1)].push(<Grid size={{xs: 6}}><Box display="flex" justifyContent={"center"} alignItems="center"><Player player={v.nickname} /></Box>
        //</Grid>);
    }

    // Incase the server sends any extra text, display it after the answer
    let extra_info: React.JSX.Element = <></>;
    if (lobby.current_question.category === AppConstants.CATEGORY_MOST_LIKELY) {
        correct_class = "";
        status_image = CORRECT_IMAGE;
        status_text = translate.answerCorrect;

        // Update text from 'CORRECT ANSWER' to 'MOST LIKELY'
        correct_answer_text = categories.find(c => c.id === AppConstants.CATEGORY_MOST_LIKELY)?.name.toUpperCase();
        //if(lobby.drink.text && lobby.drink.text.length > 0)
        //  correct_answer = lobby.drink.text;

        // Check if we're the one who needs to drink (or if it was a DRAW)
        if (correct_answer.toLowerCase() === lobby.nickname.toLowerCase() || lobby.drink.correct_option_id === -1) {
            correct_class = "-wrong";
            status_image = WRONG_IMAGE;
            status_text = translate.answerIncorrect;
        }
    } else if (lobby.current_question.category === AppConstants.CATEGORY_PICK_SIDE && lobby.drink.question_extra && lobby.drink.question_extra.toLowerCase() === "yatzy") {
        correct_answer_text = translate.yatzy;
    } else if (lobby.drink.question_extra && lobby.drink.question_extra.length > 0) {
        extra_info = (
            <Typography align='center' color={theme.palette.success.light}>
                {lobby.drink.question_extra}
            </Typography>
        );
    }

    // Check if we were afk
    if (lobby.drink.timeout.length > 0) {
        lobby.drink.timeout.forEach((v) => {
            if (v.toLowerCase() === lobby.nickname.toLowerCase()) {
                correct_class = "-wrong";
                status_image = WRONG_IMAGE;
                status_text = translate.answerIncorrect;
            }
        });
    }

    // Ready text
    let ready: React.JSX.Element = <></>;
    if (lobby.playing) {
        if (!lobby.ready) ready = (<Button sx={btnStyle} variant='contained' onClick={onReady}>{translate.ready}</Button>);
        else {
            if (lobby.ready_status.length > 0) ready = (<Button sx={btnStyle} variant='contained' color="secondary">{AppUtils.replaceLanguage(translate.readyStatus, { "%c": lobby.ready_status })}</Button>);
            else ready = (<Button sx={btnStyle} variant='contained' color="secondary">{translate.isReady}</Button>);
        }
    }

    // Image text (class)
    let image_text = (<>&nbsp;</>);
    if (lobby.playing) {
        let anim_class = "pulse" + correct_class + " 2s infinite";

        image_text = (
            <FlexCenter sx={{ marginTop: 2 }}>
                <img src={status_image} alt={status_text} className="drink-image" style={{ animation: anim_class, width: '60%' }} />
            </FlexCenter>);
    }

    if (!lobby.playing) {
        correct_class = "";
    }

    let out = [];
    if (!showTable || !lobby.playing) {
        let correct_answer_container: React.JSX.Element = <></>;
        if (lobby.playing) {
            correct_answer_container = (
                <FlexCenter direction='column' >
                    <Typography align='center' marginTop={2}>{correct_answer_text}</Typography>
                    <UIBlurBox>
                        <Typography align='center' fontSize={"1.3rem"} fontWeight={400} color={theme.palette.primary.light}>{correct_answer}</Typography>
                    </UIBlurBox>
                </FlexCenter>)
                ;
        }

        out.push(
            <>
                {image_text}
                {correct_answer_container}
            </>);
    }
    if (showTable || !lobby.playing) {
        // Show question
        out.push(
            <UIBlurBox>
                <UIHilight
                    key={200}
                    variant={lobby.playing ? "h4" : "h5"}
                    align="center"
                    text={lobby.current_question.question}
                    sx={!lobby.playing ? { fontSize: 'clamp(0.9rem, 2vw, 1.35rem)' } : { fontSize: 'clamp(1.1rem, 3vw, 1.5rem)' }}
                />
            </UIBlurBox>
        );
        out.push(extra_info)

        AppUtils.log("[Drinking] Correct option ID is", lobby.drink.correct_option_id);
        AppUtils.log("[Drinking] Table options are:", table_options);
        let redColor = theme.palette.error.light
        let oc = [redColor, redColor, redColor, redColor, redColor];
        if (oc[(lobby.drink.correct_option_id - 1)] !== undefined) oc[(lobby.drink.correct_option_id - 1)] = theme.palette.success.light;

        let tmp = [];
        const numOptions = lobby.current_question.options.length;
        // Each card takes equal share; floor at 3 (4 cols = full width for 4+ options)
        let gridWidth = Math.max(3, Math.floor(12 / numOptions));
        // On xl when !playing, constrain the container so cards are wider
        // e.g. 2 options → each card is half of a narrower container = visually bigger
        const xlContainerMaxWidth = !lobby.playing
            ? `${Math.min(numOptions * 420, 1400)}px`
            : "100%";

        // TV mode: reduce padding/gaps/minHeight so cards fit on screen
        const tvCardPadding = lobby.playing ? 1.5 : 1;
        const tvCardGap = lobby.playing ? 1.5 : 0.5;
        const tvPlayerGridMinHeight = lobby.playing ? "60px" : "36px";
        const tvOptionFontSize = lobby.playing ? 14.5 : 'clamp(0.8rem, 1.6vw, 1.15rem)';

        for (let f = 1; f <= 5; f++) {
            if (AppUtils.getArrayWithId(lobby.current_question.options, f) !== undefined) {
                let option_name = AppUtils.getArrayWithId(lobby.current_question.options, f);
                tmp.push(
                    <Grid size={{ xs: 12, md: 6, xl: gridWidth }}>
                        <Glass sx={{ padding: tvCardPadding, margin: lobby.playing ? 1 : 0.5, display: "flex", alignItems: "center" }}>
                            <Stack sx={{ width: "100%" }} gap={tvCardGap}>
                                <Typography fontSize={tvOptionFontSize} color={oc[f - 1]} textAlign={"center"} fontWeight={600}>{option_name.value}</Typography>
                                <Divider />
                                <Grid sx={{ minHeight: tvPlayerGridMinHeight }} container>
                                    {table_options[(f - 1)]}
                                </Grid>
                            </Stack>
                        </Glass>
                    </Grid>
                );
            }
        }
        out.push(
            <Box
                marginTop={lobby.playing ? 2 : 1}
                paddingLeft={lobby.playing ? 0 : 2}
                paddingRight={lobby.playing ? 0 : 2}
                sx={{
                    maxWidth: { xl: xlContainerMaxWidth },
                    mx: "auto",
                    width: "100%",
                    // TV: let this section grow to fill remaining space but never overflow
                    ...(!lobby.playing && { flex: 1, minHeight: 0 }),
                }}
            >
                <Grid container justifyContent="center">{tmp}</Grid>
            </Box>
        )
    }

    let voteText = translate.showVotes;
    if (showTable) voteText = translate.hideVotes;

    let showHideButton: React.JSX.Element = <></>;
    if (lobby.playing) showHideButton = <Button color="secondary" sx={btnStyle} variant='contained' onClick={onToggleTable}>{voteText}</Button>;
    return (
        <Box display="flex" flexDirection="column" sx={{ height: "100%", flex: 1, overflowY: 'auto' }}>
            <Box flexShrink={0} padding={1}>
                <UITimer seconds={lobby.timeleft} reset={false} message={AppUtils.replaceLanguage(translate.questionsDone, { "%q": lobby.question, "%t": lobby.number_questions })} />
            </Box>
            <FlexCenter direction='column' sx={{
                flex: 1,
                justifyContent: 'flex-start',
                overflowY: 'auto',
                paddingBottom: lobby.playing ? 2 : 1,
                scrollbarWidth: lobby.playing ? 'none' : 'thin',
                scrollbarColor: lobby.playing ? undefined : '#7dabd0ff rgba(255,255,255,0.1)',
                '&::-webkit-scrollbar': lobby.playing ? { display: 'none' } : {
                    width: '8px',
                },
                '&::-webkit-scrollbar-thumb': lobby.playing ? undefined : {
                    background: '#7dabd0ff',
                    borderRadius: '4px',
                },
                '&::-webkit-scrollbar-track': lobby.playing ? undefined : {
                    background: 'rgba(255, 255, 255, 0.1)',
                },
            }}>
                {out}
                {lobby.playing && (
                    <Stack padding={2} gap={2} sx={{ width: "100%", marginTop: 'auto' }}>
                        {showHideButton}
                        {ready}
                    </Stack>
                )}
            </FlexCenter>
        </Box>
    );
}
